export type CustomIconButtonVariant = 'default' | 'silver' | 'outlined' | 'primary';
export const CUSTOM_ICON_BUTTON_VARIANT: Record<string, CustomIconButtonVariant> = {
  default: 'default',
  silver: 'silver',
  outlined: 'outlined',
  primary: 'primary',
} as const;

export type CustomIconButtonSize = 'small' | 'medium' | 'large';
export const CUSTOM_ICON_BUTTON_SIZE: Record<string, CustomIconButtonSize> = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const getFontSize = (size?: CustomIconButtonSize): number => {
  switch (size) {
    case 'large':
      return 24;

    case 'medium':
    case 'small':
    default:
      return 16;
  }
};
